<template>
    <carousel :perPageCustom="[
        [0, 1],
        [576, 2],
        [768, 3],
        [992, 4],
        [1200, 6],
    ]" :mouse-drag="true" :paginationEnabled="false" :navigationEnabled="true" :paginationSize="20"
        :navigationPrevLabel="`<img src='/images/icons/4soft_icon_angle-left-blue.svg' alt='Předchozí' class='itb-icon itb-angle-down-icon' style='height: 1rem'>`"
        :navigationNextLabel="`<img src='/images/icons/4soft_icon_angle-right-blue.svg' alt='Další' class='itb-icon itb-angle-down-icon' style='height: 1rem'>`">
        <slide v-for="graphicItem in items" :key="graphicItem.id" class="itb-item"
            :class="{ 'itb-item-active': graphicItem.id == graphic.id }">
            <router-link :to="{
                name: 'graphicDetail',
                params: {
                    categoryAlias: graphicItem.categoryAlias,
                    subcategoryAlias: graphicItem.subcategoryAlias,
                    subcategory2Alias: graphicItem.subcategory2Alias,
                    graphicAlias: graphicItem.id + '-' + graphicItem.alias,
                    scrollToElementId: 'itb-breadcrumbs',
                },
            }" class="d-block">
                <img v-if="graphicItem.image" :src="'/uploads/' +
                    graphicItem.image.path +
                    '/' +
                    graphicItem.image.name
                    " :alt="graphicItem.nameCarousel" />
                <div class="itb-tag-wrapper" v-lazy-container="{ selector: 'img' }">
                    <img v-if="graphicItem.is_new" class="itb-tag-new itb-carousel-tag" data-src="/images/new.png"
                        alt="new" />
                    <img v-if="graphicItem.is_bestseller" class="itb-tag-bestseller itb-carousel-tag"
                        data-src="/images/bestsellers.png" alt="bestsellers" />
                    <img v-if="graphicItem.is_on_sale" class="itb-tag-on-sale itb-carousel-tag"
                        data-src="/images/sale.png" alt="sale" />
                </div>
                <h3>{{ graphicItem.nameCarousel }}</h3>
                <button v-if="appParams && appParams.staticTranslations" class="btn" :class="graphicItem.id == graphic.id
                    ? 'btn-dark'
                    : 'btn-primary'
                    " :disabled="graphicItem.id == graphic.id" type="button">
                    {{
                        graphicItem.id == graphic.id
                            ? appParams.staticTranslations[
                            "graphics.choosed_item"
                            ]
                            : appParams.staticTranslations[
                            "graphics.show_detail_btn"
                            ]
                    }}
                </button>
            </router-link>
        </slide>
    </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import { mapGetters } from "vuex";

export default {
    props: {
        items: null,
        graphic: Object,
    },
    computed: {
        ...mapGetters({
            appParams: "getAppParams",
        }),
    },
    name: "carousel-touch",
    components: {
        Carousel,
        Slide,
    },
};
</script>
